import React from 'react'
import PropTypes from 'prop-types'
import SearchIcon from 'assets/icons/search-icon'
import ClearIcon from 'assets/icons/clear-icon'
import CheckIcon from 'assets/icons/check-icon'

import {
  ClearSearchDropdownIcon,
  SearchDropdownContainer, SearchDropDownDivider,
  SearchDropdownIcon,
  SearchDropdownIconWrapper, SearchSelectContainer,
  StyledSelect
} from './style'
import Button from '../Button'
import { FormattedMessage, useIntl } from 'react-intl'

const SearchDropdown = ({
  value,
  onChange,
  options,
  label,
  field,
  error,
  placeholder,
  height = '48px',
  menuPlacement,
  marginTop = '8px',
  marginBottom = '32px',
  indicatorSize = 'none',
  dataTest,
  disabled,
  closeMenuOnSelect = true,
  infoTooltip,
  zIndex,
  menuWidth = '100%',
  buttonName = 'Button name',
  buttonOnClick,
  buttonDisabled,
  inputValue,
  onInputChange,
  hyper,
  buttonIsPresent = true,
  iconTopPosition = '-32px',
  inputMargin = '8px 0 8px 16px'
}) => {
  const intl = useIntl()
  const clearSearchAria = intl.formatMessage({ id: 'clearResults' })

  function handleClearInput() {
    onChange(null)
  }

  function handleOnCLickButton() {
    buttonOnClick(value)
    onChange(null)
  }

  return (
    <>
      <SearchDropdownContainer>
        <SearchSelectContainer buttonIsPresent={buttonIsPresent}>
          <StyledSelect
            value={value}
            onChange={onChange}
            options={options}
            label={label}
            field={field}
            error={error}
            placeholder={placeholder}
            height={height}
            menuPlacement={menuPlacement}
            marginTop={marginTop}
            marginBottom={marginBottom}
            indicatorSize={indicatorSize}
            dataTest={dataTest}
            disabled={disabled}
            closeMenuOnSelect={closeMenuOnSelect}
            infoTooltip={infoTooltip}
            zIndex={zIndex}
            paddingLeft={buttonIsPresent ? '48px' : '24px'}
            isSearchable={true}
            menuWidth={menuWidth}
            inputValue={inputValue}
            onInputChange={onInputChange}
            searchDropdown={true}
            hyper={hyper}
            inputMargin={inputMargin}
          />
        </SearchSelectContainer>
        {buttonIsPresent && (
          <Button
            height='40px'
            marginTop='0'
            onClick={handleOnCLickButton}
            isDisabled={buttonDisabled}
            withIcon={true}
            type={buttonDisabled ? 'disabledPrimary' : 'primary'}
          >
            <CheckIcon />
            <FormattedMessage id={buttonName} />
          </Button>
        )}
      </SearchDropdownContainer>
      <SearchDropdownIconWrapper>
        <SearchDropdownIcon buttonIsPresent={buttonIsPresent} iconTopPosition={iconTopPosition}>
          <SearchIcon />
        </SearchDropdownIcon>
        {buttonIsPresent && <SearchDropDownDivider iconTopPosition={iconTopPosition} />}
        {value && buttonIsPresent && (
          <ClearSearchDropdownIcon
            as="button"
            type="button"
            aria-label={clearSearchAria}
            iconTopPosition={iconTopPosition}
            onClick={handleClearInput}
          >
            <ClearIcon />
          </ClearSearchDropdownIcon>
        )}
      </SearchDropdownIconWrapper>
    </>
  )
}

SearchDropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  field: PropTypes.string.isRequired,
  error: PropTypes.shape({
    field: PropTypes.string,
    error: PropTypes.string
  }),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  height: PropTypes.string,
  menuPlacement: PropTypes.string,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
  indicatorSize: PropTypes.string,
  dataTest: PropTypes.string,
  disabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  infoTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuWidth: PropTypes.string,
  buttonName: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonDisabled: PropTypes.bool,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  hyper: PropTypes.string,
  buttonIsPresent: PropTypes.bool,
  iconTopPosition: PropTypes.string,
  inputMargin: PropTypes.string
}

export default SearchDropdown
